module.exports = __webpack_public_path__ + "static/media/testimonal.c66382cc.png";